<template>
    <div class="row" >
        <div  class="col-12 contacto">

         <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a v-for="(contenido,index) in contenidos" :key="'ktitle'+contenido.ContenidoDeMicrositioId" 
                     class="nav-item nav-link" :id="'nav-'+contenido.ContenidoDeMicrositioId+'-tab'" data-toggle="tab" :href="'#nav-'+contenido.ContenidoDeMicrositioId" role="tab" :aria-controls="'nav-'+contenido.ContenidoDeMicrositioId" aria-selected="true">
                     {{contenido.TextoDelVinculo}}--{{index}}</a>
                <!-- <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">Profile</a>
                <a class="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">Contact</a> -->
            </div>
         </nav>
            
             <div class="tab-content" id="nav-tabContent">

            <!-- <div v-if="idTabla == 0" class="seleccion">
                <select v-on:change="valorDeLaPestania($event)" class="col-12">
                <option
                  v-for="(seccion, valor) in seccionesCombo"
                  :key="seccion.OrdenDeLaSeccion"
                  :value="valor"
                  class="opcion"
          ><font class="opcion">{{ seccion.NombreDeLaSeccion }}</font></option
        >
      </select>
    </div> -->
           
            <div v-for="(contenido,index) in contenidos" :key="'kcont'+contenido.ContenidoDeMicrositioId" 
                    class="tab-pane fade" :id="'nav-'+contenido.ContenidoDeMicrositioId" role="tabpanel" :aria-labelledby="'nav-'+contenido.ContenidoDeMicrositioId+'-tab'">
                  

                    <table :id="'pestana' + idTabla" v-show="idTabla == 0" class="table table-striped table-hover table-bordered mt-4">
      <thead class="thead-dark">
        <tr><th></th><th class="titulo text-center" v-for="(titulo,index) in contenido.TextoDelContenido.split('|')" :key="index"> {{ titulo }}</th></tr>
      </thead>
      <!-- <tbody v-for="mes in seOrdenPorMeses(ordenarPorMes)" :key="mes.numero">
        <tr v-if="filtrarPorMes(mes.numero, ordenarPorMes).length != 0 && ordenarPorMes">
          <td :colspan="tituloSeccion.split('|').length + 1" class="separador"><center>{{ mes.nombre }}</center></td>
        </tr>
        <tr v-for="(data, index) in filtrarPorMes(mes.numero, ordenarPorMes)" :key="index">
          <td class="text-center">{{ index + 1 }}</td>
          <th class="texto" v-for="textoColumna in data.TextoDelContenido.split('|')" :key="textoColumna.index">{{ textoColumna }}</th>
          <th class="w-10 text-center vinculo texto" v-for="elemento in data.ArchivosDeContenidoMicrositios" :key="elemento.index">
            <a v-if="elemento.AbrirEnVisor == false" v-on:click="AbrirArchivo(elemento.RutaDelArchivo, '_self')"> {{ elemento.TextoDescripcion }}</a>
            <a v-if="elemento.AbrirEnVisor == true" v-on:click="AbreElVisor(elemento.RutaDelArchivo)">{{ elemento.TextoDescripcion }}</a>
          </th>
        </tr>
      </tbody> -->
    </table> 

                    
                    ..{{contenido.ContenidoDeMicrositioId}}--{{index}}</div>
            <!-- <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">..PROFILE.</div>
            <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">..CONTACT.</div> -->

   




            </div>

        </div>
    </div>
</template>

<script>
export default {
    props:{
        contenidos:Array,
        tituloSeccion:String,
        idTabla: Number
    },
    methods: {
         valorDeLaPestania: function(valor) {
      var elemento = "pestana" + valor.target.value;
      for (var aux in this.seccionesCombo) {
        if (aux != valor.target.value) {
          var ocultar = "pestana" + aux;
          $("#" + ocultar).hide();
        }
      }
      if ($("#" + elemento).is(":visible")) {
        $("#" + elemento).hide();
      } else {
        $("#" + elemento).show();
      }
    },
        columnasContenido(columnas){
            var respuesta = 'col-lg-'+columnas
            return respuesta;
        }
    }
}
</script>

<style scoped>
.contacto{
    /* background-color: aquamarine; */
    margin-bottom: 2em;
    background-color:rgb(247, 242, 242) ;
    opacity: 0.8;
}
.contacto h3{ 
    font-size:2em;
    font-family: 'AntenaBeta';
    
}

.elemento{
    font-size:1.2em;
    font-family: 'Myriad';
}
</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/TextoContacto.vue